module.exports = "<div class=\"container\">\n    <mat-card class=\"cardTitle\">\n        <img mat-card-image [src]=\"banner | async\"/>\n        <mat-card-content>\n          We are actively developing this module please wait up a while and we'll inform you when it's done\n        </mat-card-content>\n      </mat-card>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/under-construction/under-construction.component.html
// module id = ./src/app/under-construction/under-construction.component.html
// module chunks = main